define('OutSystems/ReactView/ControllerInitializationNavigationCallbacks',["require", "exports", "tslib", "./BaseNavigationCallbacks"], function (require, exports, tslib_1, BaseNavigationCallbacks_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var ControllerInitializationNavigationCallbacks = (function (_super) {
        tslib_1.__extends(ControllerInitializationNavigationCallbacks, _super);
        function ControllerInitializationNavigationCallbacks(history, runtime) {
            return _super.call(this, history, runtime) || this;
        }
        ControllerInitializationNavigationCallbacks.prototype.goTo = function (urlInfo, transition, replace) {
            var location = BaseNavigationCallbacks_1.default.urlToLocationDescriptor(urlInfo, transition);
            this.push(location);
        };
        ControllerInitializationNavigationCallbacks.prototype.dispose = function (callContext) { };
        return ControllerInitializationNavigationCallbacks;
    }(BaseNavigationCallbacks_1.default));
    exports.default = ControllerInitializationNavigationCallbacks;
});
//# sourceMappingURL=ControllerInitializationNavigationCallbacks.js.map;
